import { store } from "../../state/store.js";
import { norm } from "../../utils/text.js";
import { appendCell, appendStatusPill } from "../../utils/render.js";

export function renderDetailsRow(key, colspan) {
  const arr = store.programsByTpKey.get(key) || [];
  const tr = document.createElement("tr");
  tr.className = "details";

  const td = document.createElement("td");
  td.colSpan = colspan;
  tr.appendChild(td);

  const label = document.createElement("div");
  label.className = "muted";
  label.style.marginBottom = "6px";
  label.textContent = `Programme (${arr.length})`;
  td.appendChild(label);

  const scroll = document.createElement("div");
  scroll.className = "table-scroll";
  scroll.style.maxHeight = "260px";
  scroll.style.boxShadow = "none";
  td.appendChild(scroll);

  const table = document.createElement("table");
  scroll.appendChild(table);

  const thead = document.createElement("thead");
  table.appendChild(thead);

  const headRow = document.createElement("tr");
  thead.appendChild(headRow);
  appendCell(headRow, "Programm", { header: true });
  appendCell(headRow, "SID", { header: true, className: "nowrap" });
  appendCell(headRow, "Sprache", { header: true });
  appendCell(headRow, "Typ", { header: true });
  appendCell(headRow, "Aufloesung", { header: true });
  appendCell(headRow, "Status", { header: true });

  const tbody = document.createElement("tbody");
  table.appendChild(tbody);

  for (const p of arr.slice(0, 500)) {
    const row = document.createElement("tr");
    const enc = p.encrypted === true || norm(p.encrypted) === "true";
    const name = p.program_name ?? p.name ?? p.service_name ?? "";

    const nameCell = appendCell(row, name, { className: "prog-cell" });
    nameCell.dataset.full = String(name);
    appendCell(row, p.sid ?? "", { className: "nowrap", align: "right" });
    appendCell(row, p.language ?? "", { className: "nowrap" });
    appendCell(row, p.type ?? "", { className: "nowrap" });
    appendCell(row, p.resolution ?? "", { className: "nowrap" });

    const statusCell = appendCell(row, "", { className: "nowrap" });
    appendStatusPill(
      statusCell,
      enc ? "encrypted" : "free",
      enc
        ? "background:#F39200;color:white;border-color:#F39200"
        : "background:#8E8E8E;color:white;border-color:#8E8E8E"
    );

    tbody.appendChild(row);
  }

  if (!tbody.childElementCount) {
    const emptyRow = document.createElement("tr");
    appendCell(emptyRow, "Keine Programme gefunden.", {
      className: "muted",
      colSpan: 6,
    });
    tbody.appendChild(emptyRow);
  }

  return tr;
}
